import {
  Action,
  ActionType,
  IDashboardInfoResponse,
} from "models/dashboard/dashboardInfo";
import createReducer from "redux/createReducer";

export interface DashboardInfoReducerType {
  loading: boolean;
  error?: string;
  dashboardInfoResponse?: IDashboardInfoResponse;
}

const defaultState: DashboardInfoReducerType = {
  loading: false,
  error: undefined,
  dashboardInfoResponse: undefined,
};

export const dashboardInfoReducer = createReducer<DashboardInfoReducerType>(
  defaultState,
  {
    [ActionType.DASHBOARD_INFO](state: DashboardInfoReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DASHBOARD_INFO_ERROR](
      state: DashboardInfoReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.DASHBOARD_INFO_SUCCESS](
      state: DashboardInfoReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        dashboardInfoResponse: action.payload,
      };
    },

    [ActionType.DASHBOARD_INFO_RESET](state: DashboardInfoReducerType) {
      return {
        ...state,
        loading: false,
        error: null,
        dashboardInfoResponse: undefined,
      };
    },
  }
);
